export function opsEntityPath(
  row: Record<string, unknown>,
  opts?: { slug?: string; dataSource?: string },
): string | null {
  const slug = opts?.slug || '';
  const dataSource = String(opts?.dataSource || row.kind || '');
  const id = String(row._id || '');
  if (!id) return null;

  if (slug === 'partner-wise-report' || dataSource === 'drivers' || row.kind === 'partner') {
    return `/partners/${String(row.driverId || id)}`;
  }
  if (slug === 'trip-request-report' || dataSource === 'rides' || dataSource === 'ride') {
    return `/trips/${id}`;
  }
  if ([
    'food_orders', 'grocery_orders', 'porter_orders', 'on_demand_bookings', 'event_bookings',
    'food', 'grocery', 'porter', 'service', 'event',
  ].includes(dataSource)) {
    return `/orders/${id}`;
  }
  if (dataSource === 'users') {
    return String(row.userType) === 'customer' ? `/customers/${id}` : `/partners/${id}`;
  }
  if (row.kind === 'ride') return `/trips/${id}`;
  if (row.kind) return `/orders/${id}`;
  return null;
}

export function isPartnerUserType(userType?: string) {
  return ['driver', 'delivery_partner', 'service_provider', 'merchant', 'vendor'].includes(userType || '');
}
